import axios from "axios";
import { firestore } from '@/firebaseConfig'

export default class CatalogService {
    loadLegacyBundles() {
        return new Promise((resolve, reject) => {
            axios.get("https://s3.amazonaws.com/static.ws.igloocreations.com/ondago/2.00/bundles.json").then((response) => {
                if (response) {
                    resolve(response.data);
                } else {
                    resolve(null);
                }
            }).catch((error) => {
                reject(error);
            });
        });
    }

    loadLegacySections() {
        return new Promise((resolve, reject) => {
            axios.get("https://s3.amazonaws.com/static.ws.igloocreations.com/ondago/2.00/sections.json").then((response) => {
                if (response) {
                    resolve(response.data);
                } else {
                    resolve(null);
                }
            }).catch((error) => {
                reject(error);
            });
        });
    }

    loadCatalogBundle(bundleId) {
        return new Promise((resolve, reject) => {
            firestore.collection("catalogMapBundles").doc(bundleId).get().then((doc) => {
                resolve(doc.data());
              }).catch((error) => {
                reject(error);
              });
        });
    }
}